const NS = 'BrowserInfoService'; // jshint ignore:line

export default class BrowserInfoService {

  static getBrowserInfo() {
    const ua = navigator.userAgent

    let tem, M = ua.match(/(opera|chrome|safari|firefox|msie|Edge|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (ua.indexOf("Edge") > -1) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return {
        name: 'Edge',
        version: (tem[1] || '')
      };
    }
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return {
        name: 'IE',
        version: (tem[1] || '')
      };
    }

    if (M[1] === 'Chrome') {
      tem = ua.match(/\bOPR\/(\d+)/);
      if (tem != null) {
        return {
          name: 'Opera',
          version: tem[1]
        };
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
      M.splice(1, 1, tem[1]);
    }
    return {
      name: M[0],
      version: M[1]
    };
  }
}
